export enum AppErrorCode {
    USER_NAME_TAKEN = 'USER_NAME_TAKEN',
    SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
    DUPLICATED_DOCUMENT_IDENTIFIER = 'DUPLICATED_DOCUMENT_IDENTIFIER',
}